import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api.service';

export interface ColumnValueDistribution {
  value: string;
  total: number;
}

interface ColumnValueDistributionResponse {
  records: ColumnValueDistribution[];
}

export function useColumnValueDistribution(
  pipelineNodeId: string | null | undefined,
  columnId: string | null | undefined,
  limit: number = 20,
  enabled: boolean = true
) {
  return useQuery<ColumnValueDistribution[]>({
    queryKey: ['column-value-distribution', pipelineNodeId, columnId, limit],
    queryFn: async () => {
      if (!pipelineNodeId || !columnId) {
        return [];
      }
      const result = await ApiService.getInstance().request(
        'GET',
        `/pipelinenodes/${pipelineNodeId}/column/${columnId}/distro`,
        { limit }
      ) as ColumnValueDistributionResponse;
      return result.records || [];
    },
    enabled: enabled && !!pipelineNodeId && !!columnId,
    staleTime: 10 * 60 * 1000, // 10 minutes - aggressive caching
    gcTime: 30 * 60 * 1000, // 30 minutes - keep in cache for a long time
  });
}

